import React from 'react'
import LoggedInWidget from './LoggedInWidget'
import LoggedOutWidget from './LoggedOutWidget'
import PropTypes from 'prop-types'

const LoginWidget = (props) => {
	if (props.isLoggedIn) {
		return <LoggedInWidget {...props} />
	}
	return <LoggedOutWidget {...props} />
}
LoginWidget.propTypes = {
	isLoggedIn: PropTypes.bool
}

export default LoginWidget


// WEBPACK FOOTER //
// ./src/components/LoginWidget.js